import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { LoginHjaelpIndstillinger } from "./login-hjaelp-indstillinger.model";

@Injectable({ providedIn: "root" })
export class LoginHjaelpRepository {
    constructor(private readonly umbracoHttp: UmbracoHttpClient) {}

    public hentIndstillinger(): Observable<LoginHjaelpIndstillinger> {
        return this.umbracoHttp.hentSideData<LoginHjaelpIndstillinger>("login-hjaelp");
    }
}
